import BaseApi from '@/api/Base/BaseApi'
import { CreateRoomPayload, RenameRoomPayload, SendMessagePayload, GetRoomListResponse, GetRoomMessagesResponse, CreateRoomResponse, RenameRoomResponse, SendMessageResponse, CancelMessagePayload, CancelMessageResponse } from '@/api/Agent/types'

const ROOT = '/ai-agent'

export default class AgentApi extends BaseApi {
  getRoomList(cursor?: string | null) {
    return this.agent.get<GetRoomListResponse>(`${ROOT}/rooms`, {
      params: cursor ? { cursor } : undefined,
    })
  }

  getRoomMessages(roomId: string, cursor?: string | null) {
    return this.agent.get<GetRoomMessagesResponse>(`${ROOT}/rooms/${roomId}/messages`, {
      params: cursor ? { cursor } : undefined,
    })
  }

  createRoom(payload?: CreateRoomPayload) {
    return this.agent.post<CreateRoomResponse>(`${ROOT}/rooms`, payload)
  }

  renameRoom(payload: RenameRoomPayload) {
    const { roomId, ...rest } = payload
    return this.agent.put<RenameRoomResponse>(`${ROOT}/rooms/${roomId}`, rest)
  }

  deleteRoom(roomId: string) {
    return this.agent.delete(`${ROOT}/rooms/${roomId}`)
  }

  sendMessage(payload: SendMessagePayload) {
    const { roomId, ...rest } = payload
    return this.agent.post<SendMessageResponse>(`${ROOT}/rooms/${roomId}/messages`, rest)
  }

  cancelMessage(payload: CancelMessagePayload) {
    const { roomId, messageId } = payload
    return this.agent.post<CancelMessageResponse>(`${ROOT}/rooms/${roomId}/messages/${messageId}/cancel`)
  }
}
